import './features-table';
import './top-banner';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import variables
import './variables.scss';

// Import style for web component
import styles from './web-component-style.scss?inline';

/**
 * Web component representing the upgrade upsell page
 *
 * @augments LitElement
 */
@customElement( 'uap-page-upgrade' ) // eslint-disable-line require-jsdoc
export class AutomatorUpgrade extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * Renders the component
	 *
	 * @return {TemplateResult|undefined} The template
	 */
	render() {
		return html`
			<div class="page">
				<div class="page-content">
					<uap-page-upgrade-banner></uap-page-upgrade-banner>

					<div class="page-content-inner">
						<uap-page-upgrade-table></uap-page-upgrade-table>
					</div>
				</div>
			</div>
		`;
	}
}
